import React from "react";
import PropTypes from "prop-types";

class Logout extends React.Component {
  componentWillMount() {
    this.props.onLogout();
  }

  render() {
    return null;
  }
}

Logout.propTypes = {
  onLogout: PropTypes.func
};

export default Logout;



/** WEBPACK FOOTER **
 ** ./src/components/Logout.jsx
 **/